import React from "react";
import {Box, Grid, Skeleton, Stack} from "@mui/material";
import {TextFieldSkeleton, RadioSkeleton, CheckboxSkeleton} from "@/components/forms/form-skeletons";


const DropdownSkeleton = () => (
  <Stack
    width="100%"
    gap="0.8rem"
    data-testid="contact-form_dropdown-skeleton"
  >
    <Skeleton height="2rem" width="20rem" />
    <Box width="100%">
      <Skeleton
        variant="rounded"
        height="4.5rem"
        sx={{
          width: {xs: "100%", md: "60%" },
          justifySelf: {xs: "start", md: "end" },
          borderRadius: "1rem"
        }}
      />
    </Box>

  </Stack>
);


const ContactFormSkeleton = () => (
  <Stack gap="1.6rem">
    <Grid container spacing={1}>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="contact-form" /></Grid>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="contact-form" /></Grid>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="contact-form" /></Grid>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="contact-form" /></Grid>
    </Grid>
    <RadioSkeleton testId="contact-form" />
    <DropdownSkeleton />
    <RadioSkeleton testId="contact-form" />
    <CheckboxSkeleton testId="contact-form" />
    <CheckboxSkeleton testId="contact-form" />
    <Box width="100%">
      <Skeleton
        variant="rounded"
        height="4rem"
        width="20rem"
        sx={{ justifySelf: "end", borderRadius: "10rem" }}
        data-testid="contact-form_submit-button-skeleton"
      />
    </Box>
  </Stack>
);

export default ContactFormSkeleton;